import RecipeBlock from './RecipeBlock';

export default RecipeBlock;
